import { DAYS_TO_MILLIS, HOURS_TO_MILLIS } from "lopermut"
import { z } from "zod"

export const KnowledgeBaseItemKind = {
  Text: "Text",
  File: "File",
  QuestionAndAnswer: "QuestionAndAnswer",
  Website: "Website",
} as const

export const KnowledgeBaseItemKindWithChangeLog = [
  KnowledgeBaseItemKind.Text,
  KnowledgeBaseItemKind.QuestionAndAnswer,
]

export type KnowledgeBaseItemKind =
  (typeof KnowledgeBaseItemKind)[keyof typeof KnowledgeBaseItemKind]

export const KnowledgeBaseWebsiteRefreshScheduleEnum = {
  Hourly: "Hourly",
  Every4Hours: "Every4Hours",
  Every12Hours: "Every12Hours",
  Daily: "Daily",
  Every3Days: "Every3Days",
  Weekly: "Weekly",
  Every30Days: "Every30Days",
} as const

export type KnowledgeBaseWebsiteRefreshSchedule =
  (typeof KnowledgeBaseWebsiteRefreshScheduleEnum)[keyof typeof KnowledgeBaseWebsiteRefreshScheduleEnum]

export function getKnowledgeBaseWebsiteRefreshDelayMs(
  frequency: KnowledgeBaseWebsiteRefreshSchedule,
) {
  switch (frequency) {
    case "Hourly":
      return 1 * HOURS_TO_MILLIS
    case "Every4Hours":
      return 4 * HOURS_TO_MILLIS
    case "Every12Hours":
      return 12 * HOURS_TO_MILLIS
    case "Daily":
      return 1 * DAYS_TO_MILLIS
    case "Every3Days":
      return 3 * DAYS_TO_MILLIS
    case "Weekly":
      return 7 * DAYS_TO_MILLIS
    case "Every30Days":
      return 30 * DAYS_TO_MILLIS
  }
}

export const KnowledgeBaseItemSchema = z.object({
  id: z.bigint().transform(String),
  campaignId: z
    .bigint()
    .nullable()
    .transform((value) => value?.toString()),
  kind: z.enum(KnowledgeBaseItemKind),
  content: z.string().nullable(),
  title: z.string().nullable(),
  order: z.number(),
  hasChangeLog: z.boolean(),
  retrievedAt: z.date().nullable(),
  fetchFailedAt: z.date().nullable(),
  isRetrieving: z.boolean().nullable(),
  websiteRefreshFrequency: z.enum(KnowledgeBaseWebsiteRefreshScheduleEnum).nullable(),
})

export const KnowledgeBaseSchema = z.array(KnowledgeBaseItemSchema)

export const PlaygroundKnowledgeBaseResponseSchema = z.object({
  querySummary: z.string(),
  results: z.array(
    z.object({
      score: z.number().optional(),
      id: z.string().optional(),
      metadata: z.object({
        content: z.string(),
        index: z.number().optional(),
        knowledgeBaseItemId: z.string().optional(),
      }),
    }),
  ),
})
